import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO component for managing document head metadata
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page meta description
 * @param {string} [props.keywords] - Page meta keywords (optional)
 * @param {string} [props.ogType='website'] - Open Graph type
 * @param {string} [props.ogImage] - Open Graph image URL (optional)
 * @param {string} [props.twitterCard='summary_large_image'] - Twitter card type
 */
const SEO = ({
  title,
  description,
  keywords,
  ogType = 'website',
  ogImage,
  twitterCard = 'summary_large_image',
}) => {
  // Default site name to append to titles
  const siteName = 'ZeniTech Solutions';
  const fullTitle = `${title} | ${siteName}`;
  
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="title" content={title} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph tags for social media sharing */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
};

export default SEO;